<script>
// open pdf link in new tab!
export let params;
export let currentRoute;


import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import { navigateTo } from 'svelte-router-spa';
import SvelteSeo from 'svelte-seo';



const api_url = app_.env.API_URL;


const slug = currentRoute.namedParams.slug;

const token = get(auth).token;


let loading = true;


async function getPDF() {

	const url = `${api_url}coaches/resource/pdf/${slug}`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	
	const result = await resp.json();


	if (!resp.ok) {

		if (resp.status === 404) {
			navigateTo('/my/resources');
		}

		throw new Error(result.detail);

	}

	return result;

}


getPDF().then(pdf => {
	window.open(pdf.pdf_link, '_blank');
	loading = false;
	navigateTo('/my/resources')
});


</script>



<style>


</style>


{#if loading}
<Loading />
{/if}



